import _ from 'lodash'
import { event } from 'vue-gtag'

export default (context, inject) => {
  const scrollToTop = () => {
    if (process.client) {
      window.scroll({ top: 0, left: 0, behavior: 'smooth' })
    }
    return true
  }

  const numberFormat = (number) => {
    if (number == null) { number = 0 }
    return number.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
  }

  const maximumString = (data, max) => {
    if (data.length > max) { return data.substring(0, max) }
    return data
  }

  const secondsToTimer = (number) => {
    const minute = Math.floor(number / 60)
    const second = Number(number) % 60

    return minute.toString().padStart(2, 0) + ':' + second.toString().padStart(2, 0)
  }

  const currencyFormat = (number) => {
    if (number == null) { number = 0 }
    return 'Rp' + number.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
  }

  const timeStampToDateTime = (number) => {
    if (number) {
      const a = new Date(number)
      const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      const year = a.getFullYear()
      const month = months[a.getMonth()]
      const date = a.getDate()
      const hour = a.getHours()
      const min = a.getMinutes()
      const sec = a.getSeconds()
      const time = date + ' ' + month + ' ' + year + ' ' + hour + ':' + min + ':' + sec
      return time
    } else { return '-' }
  }

  const momentRoundDate = (date, duration, method) => {
    // eslint-disable-next-line no-undef
    return $nuxt.$moment(Math[method]((+date) / (+duration)) * (+duration))
  }

  const phoneNumberSecret = (number) => {
    return number ? number.replace(/.(?=.{4})/g, '*') : ''
  }

  const scrollTop = () => {
    document.body.scrollTop = 0 // For Safari
    document.documentElement.scrollTop = 0 // For Chrome, Firefox, IE and Opera
  }

  const getLocalTimeZone = (formatted) => {
    switch (formatted) {
      case '+07:00': return 'WIB'
      case '+08:00': return 'WITA'
      case '+09:00': return 'WIT'
      default: return 'GMT ' + formatted
    }
  }

  const onlyNumber = ($event) => {
    const keyCode = $event.keyCode ? $event.keyCode : $event.which
    if (keyCode < 48 || keyCode > 57) {
      $event.preventDefault()
    }
  }

  const tracker = (payload) => {
    const { action, category, label = '' } = payload
    event(action, {
      event_category: category,
      event_label: label
    })
  }

  const inputTracker = _.debounce((payload) => {
    tracker(payload)
  }, 500)

  inject('numberFormat', numberFormat)
  inject('maximumString', maximumString)
  inject('scrollToTop', scrollToTop)
  inject('secondsToTimer', secondsToTimer)
  inject('momentRoundDate', momentRoundDate)
  inject('phoneNumberSecret', phoneNumberSecret)
  inject('currencyFormat', currencyFormat)
  inject('timeStampToDateTime', timeStampToDateTime)
  inject('scrollTop', scrollTop)
  inject('getLocalTimeZone', getLocalTimeZone)
  inject('onlyNumber', onlyNumber)
  inject('tracker', tracker)
  inject('inputTracker', inputTracker)
  context.$tracker = tracker
  context.$scrollToTop = scrollToTop
}
